import React, { useContext, useEffect } from "react";
import { ReactComponent as Error404 } from "../../../img/404.svg";
import { StyledErrorContainer, StyledErrorTitle, StyledErrorP } from "./errorPage.style.js";
import StateContext from "../../../context/StateContext";
import { useHistory } from "react-router";
import Sentry from "services/sentry";
import LinkButton from "../linkButton/LinkButton.component";

const ErrorPage = (props) => {
	const { dispatch, ACTIONS } = useContext(StateContext);
	const { state } = useHistory();

	useEffect(() => {
		if (state) console.error("ErrorPage.js ~ ErrorPage ~ state", state.toJSON() || state);
		let didCancel = false;
		if (!didCancel) {
			dispatch({ type: ACTIONS.SET_SPINNER, payload: false });
		}
		return () => (didCancel = true);
	});

	return (
		<StyledErrorContainer>
			<StyledErrorTitle>Oh, dear</StyledErrorTitle>
			<StyledErrorP>Something went wrong, we’re working on fixing it. </StyledErrorP>
			<StyledErrorP>
				If you’re still stuck, shoot us an email at{" "}
				<a rel="noreferrer" target="_blank" href="mailto:support@fixel.ai">
					support@fixel.ai
				</a>
			</StyledErrorP>
			<StyledErrorP>
				or report to us directly&nbsp;
				<LinkButton onClick={()=>Sentry.showReportDialog({eventId:Sentry.captureMessage("Error page invocation")})}>Here</LinkButton>
			</StyledErrorP>
			<Error404 />
		</StyledErrorContainer>
	);
};
export default ErrorPage;
